import React from "react";
// import Logo from "../../assets/images/Logo/Logo.png";
import { Stack, Box } from "@mui/material";
import { AppLogo } from "./AppLogo";

export const ErrorScreen = ({ text }) => {
  return (
    <Box
      sx={{
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack direction="column" alignItems="center" gap="16px">
        {/* <img
          src={Logo}
          alt="logo"
          style={{
            width: "100px",
          }}
        /> */}
        <AppLogo
          alt="logo"
          sx={{ maxHeight: "80px", maxWidth: "100px", objectFit: "contain" }}
          skeletonSx={{ width: 100, height: 80 }}
        />
        <p
          style={{
            fontWeight: 600,
          }}
        >
          {text}
        </p>
      </Stack>
    </Box>
  );
};
